import { Validators } from '@angular/forms';
import {
  FormField,
  FormFieldList,
  SfAmountInputFormField,
  SfDatePickerFormField,
  SfInputFormField,
  SfSelectFormField,
} from 'ngx-smart-form';
import { AmountDependencyField } from './amount-dependency-field';
import {
  getSelectOptions,
  LiberoProfessionista,
  ProfessioneEnum,
  SituazioneAbitativaEnum,
  StatoCivileEnum,
  TipoContrattoLavoroEnum,
} from '../models/libero-professionista';
import { PraticaType } from '../../../interfaces/pratica';
import { getModalitaIdentificazioneOptions } from '../models/modalita-identificazione.enum';

export const getLiberoProfessionistFields = (
  liberoProfessionista: LiberoProfessionista,
  praticaType?: PraticaType
) => {
  let fields: [
    FormFieldList<LiberoProfessionista>,
    FormFieldList<LiberoProfessionista>
  ];
  if (praticaType === 'FIN') {
    fields = [
      [
        [
          new SfInputFormField({
            formControlName: 'nome',
            label: 'Nome richiedente',
            required: true,
          }),
          new SfInputFormField({
            formControlName: 'cognome',
            label: 'Cognome richiedente',
            required: true,
          }),
        ],

        [
          new SfInputFormField({
            formControlName: 'denominazione',
            label: 'Denominazione',
            required: true,
          }),
          new SfInputFormField({
            formControlName: 'codiceFiscale',
            label: 'Codice fiscale',
            required: true,
            validators: [
              Validators.pattern(
                '^[0-9]{11}$|^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$'
              ),
            ],
          }),
        ],

        [
          new SfSelectFormField({
            formControlName: 'professione',
            label: 'Professione',
            required: true,
            options: getSelectOptions(ProfessioneEnum),
          }),

          new SfInputFormField({
            formControlName: 'iban',
            label: 'Iban',
            required: true,
            validators: [
              Validators.pattern(
                'IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}'
              ),
            ],
          }),
        ],

        [
          new SfInputFormField({
            formControlName: 'iscrizioneAlbo',
            label: 'Inserisci Albo/ordine iscrizione',
            required: true,
          }),
          new SfInputFormField({
            formControlName: 'numeroIscrizioneAlbo',
            label: 'Numero Iscrizione Albo/Ordine',
            required: true,
            validators: [Validators.pattern('^[0-9]*$')],
          }),
          new SfDatePickerFormField({
            formControlName: 'dataIscrizioneAlbo',
            label: 'Data iscrizione albo/ordine',
            required: true,
          }),
        ],

        [
          new SfInputFormField({
            formControlName: 'pec',
            label: 'PEC',
            required: true,
            validators: [Validators.email],
          }),
          new SfInputFormField({
            formControlName: 'confermaPec',
            label: 'Conferma PEC',
            required: true,
            validators: [Validators.email],
          }),
        ],

        [
          new SfInputFormField({
            formControlName: 'codiceAteco',
            label: 'Codice ATECO',
            required: true,
          }),
          new SfInputFormField({
            formControlName: 'partitaIva',
            label: 'Partita IVA',
            required: true,
            validators: [
              Validators.pattern(
                '^[0-9]{11}$|^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$'
              ),
            ],
          }),
        ],
      ],

      [
        [
          new SfSelectFormField({
            formControlName: 'situazioneAbitativa',
            label: 'Situazione abitativa',
            required: true,
            options: getSelectOptions(SituazioneAbitativaEnum),
          }),
          new AmountDependencyField(
            {
              formControlName: 'affitto',
              label: 'Importo affitto',
              required: true,
              disabled:
                liberoProfessionista.situazioneAbitativa !==
                SituazioneAbitativaEnum.PROPRIETA,
              value:
                liberoProfessionista.situazioneAbitativa !==
                SituazioneAbitativaEnum.PROPRIETA
                  ? '0'
                  : liberoProfessionista.affitto,
              currency: '€',
            },
            'situazioneAbitativa'
          ),
        ],

        [
          new SfAmountInputFormField({
            formControlName: 'numeroDipendenti',
            label: 'Numero dipendenti',
            required: true,
            decimals: 0,
          }),
          new SfInputFormField({
            formControlName: 'annoRilevazioneDipendenti',
            label: 'Anno rilevazione dipendenti',
            required: true,
            validators: [Validators.pattern('^[0-9]*$')],
          }),
        ],
      ],
    ];
  } else {
    fields = [
      [
        [
          new SfInputFormField({
            formControlName: 'denominazione',
            label: 'Denominazione',
            required: true,
          }),
          new SfInputFormField({
            formControlName: 'codiceFiscale',
            label: 'Codice fiscale',
            required: true,
            validators: [
              Validators.pattern(
                '^[0-9]{11}$|^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$'
              ),
            ],
          }),
        ],
        [
          new SfSelectFormField({
            formControlName: 'modalitaIdentificazione',
            label: 'Modalità di identificazione',
            required: true,
            options: getModalitaIdentificazioneOptions(),
          }),
          new SfInputFormField({
            formControlName: 'sae',
            label: 'SAE',
            required: true,
          }),
        ],
      ],
      [],
    ];
  }

  fields
    .flat()
    .forEach((row) =>
      row.forEach(
        (field) =>
          (field.value =
            field.value !== undefined
              ? field instanceof SfDatePickerFormField
                ? new Date(field.value)
                : field.value
              : field instanceof SfDatePickerFormField
              ? new Date(liberoProfessionista?.[field.formControlName])
              : liberoProfessionista?.[field.formControlName])
      )
    );
  return fields;
};
